import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { roleTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const deleteRole: roleTypes.DeleteRole = ({ id }) => {
  return axios.delete(`/roles/${id}`);
};

type UseDeleteRoleOptions = {
  config?: MutationConfig<typeof deleteRole>;
};

export function useDeleteRole({ config = {} }: UseDeleteRoleOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('delete-role', 'Deleting role...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['roles']);
      queryClient.invalidateQueries(['accounts']);
      queryClient.invalidateQueries(['account-me']);
      toasts.loadingToast.success('delete-role', 'Role deleted successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('delete-role', serverMessage);
      // Role was already deleted (e.g. from another tab) — remove it from the
      // local cache so the stale row doesn't stay in the table indefinitely.
      if (error.response?.status === 404) {
        queryClient.invalidateQueries(['roles']);
        queryClient.invalidateQueries(['accounts']);
        queryClient.invalidateQueries(['account-me']);
      }
      config.onError?.(error, ...args);
    },
    mutationFn: deleteRole,
  });
}
